var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-button-component"},[_c('big-button',{staticClass:"cta",attrs:{"href":"/register","main":true}},[_vm._v("Pre-register")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }